export enum NotificationPriorityEnum {
  high = 'high',
  normal = 'normal',
  low = 'low',
}
